import { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { PaginatedTable } from 'root/src/client/v2/common/components/PaginatedTable';
import { cn } from 'root/src/client/v2/common/helpers/cn';
import { LeaderboardRow } from 'root/src/client/v2/_pages/creators-leaderboard/redesign/LeaderboardRow';
import { RANKING_TAB_OPTIONS } from 'root/src/client/v2/_pages/creators-leaderboard/redesign/creatorsLeaderboard.helpers';
const RANKING_ORDER = RANKING_TAB_OPTIONS.map(option => option.value);
const tabContentVariants = {
    enter: (dir) => ({ x: dir * 36, opacity: 0 }),
    center: { x: 0, opacity: 1 },
    exit: (dir) => ({ x: dir * -36, opacity: 0 }),
};
// Server-paginated leaderboard list. The ranking-type switch slides the content in as a directional
// carousel (matching the other redesign tables).
export const LeaderboardList = ({ creators, activeRanking, page, pageCount, pageSize, onPageChange, onPageSizeChange, isFetching, emptyTitle, emptyDescription, }) => {
    const reduce = useReducedMotion();
    const prevRankingIndex = useRef(RANKING_ORDER.indexOf(activeRanking));
    const [direction, setDirection] = useState(0);
    useEffect(() => {
        const nextIndex = RANKING_ORDER.indexOf(activeRanking);
        setDirection(Math.sign(nextIndex - prevRankingIndex.current));
        prevRankingIndex.current = nextIndex;
    }, [activeRanking]);
    if (!creators.length) {
        return (<div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-white/[0.1] px-6 py-16 text-center">
				<p className="text-sm font-semibold text-foreground">{emptyTitle}</p>
				<p className="mt-1 max-w-sm text-xs text-muted-foreground">{emptyDescription}</p>
			</div>);
    }
    return (<PaginatedTable page={page} pageCount={pageCount} pageSize={pageSize} onPageChange={onPageChange} onPageSizeChange={onPageSizeChange}>
			<div className="overflow-hidden">
				<AnimatePresence mode="wait" custom={direction} initial={false}>
					<motion.div key={activeRanking} custom={direction} variants={reduce ? undefined : tabContentVariants} initial="enter" animate="center" exit="exit" transition={{ duration: 0.18, ease: 'easeOut' }} className={cn('flex flex-col gap-2 transition-opacity', isFetching && 'opacity-60')} aria-busy={isFetching}>
						{creators.map(creator => (<LeaderboardRow key={creator.userId} creator={creator}/>))}
					</motion.div>
				</AnimatePresence>
			</div>
		</PaginatedTable>);
};
